module.exports = __webpack_public_path__ + "img/kabum-logo.7c245070.png";